import React from 'react';

import classes from './SideDrawer.module.css';
import Backdrop from '../../UI/Backdrop/Backdrop';
import Aux from '../../../hoc/Auxx/Auxx';
import NavigationItems from '../NavigationItems/NavigationItems';

const sideDrawer = ( props ) => {
    let attachedClasses = [classes.SideDrawer, classes.Close];
    if (props.open) {
        attachedClasses = [classes.SideDrawer, classes.Open];
    }
    return (
        <Aux>
            <Backdrop show={props.open} clicked={props.sideDrawerClosed}/>
            <div className={attachedClasses.join(' ')}>
                <nav>
                    <NavigationItems
                        isAuthenticated={props.isAuth}
                        userId={props.userId}
                        accountId={props.accountId}
                        userPermissions={props.userPermissions}
                        notifications={props.notifications}
                        toggleSearch={props.toggleSearch}
                        toggleGamesSearch={props.toggleGamesSearch}
                        toggleHelp={props.helpDrawerToggleClicked}
                        userClicked={props.userDrawerToggleClicked}
                        userEditOpen={props.userEditOpen}
                        sideDrawerClosed={props.sideDrawerClosed}
                        location={props.location}
                        openLogin={props.openLogin}
                        openMiscSearch={props.openMiscSearch}
                        openNotifications={props.openNotifications}
                        isInToolbar={false}
                        token={props.token}
                    />
                </nav>
            </div>
        </Aux>
    );
};

export default sideDrawer;